import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { productInfoSelector } from 'ctm-selectors';
import { pageContext, apiAction } from 'ctm-util-functions';
import { getExpiredQuoteImageSelector } from 'ctm-selectors/selectors/brand_content';

import { SimpleFlexbox } from '../flexbox/flexbox';
import { Picture } from '../picture/picture';
import { Text } from '../text/text';
import { InternalLink } from '../internal_link/internal_link';

import styles from './insurer_handover_page.css';

class _InsurerHandoverPage extends Component {

    constructor(props) {
        super(props);
        // store a local reference to the page schema model
        this.pageSchemaModel = pageContext.getProps().models.pageSchemaModel;

        // Schemas created here to avoid object literals in render method
    }

    /**
     * Before rendering, check if we can redirect, if so, keep displaying the pleaseWait page then redirect
     */
     // eslint-disable-next-line camelcase
     UNSAFE_componentWillMount = () => {
         const { productInfo: { isQuoteValid, product }, dispatch } = this.props;

         const apiSchema = {
             url: '/event',
             type: 'POST',
             requestAction: 'ONLINE_HANDOVER',
             requestPayload: 'lead',
             failureType: 'non-fatal'
         };

         // we still need to show the please wait before the partner's page loaded
         // otherwise we have nothing to render in the body section
         if (isQuoteValid) {
             dispatch({
                 type: 'SET_PAGE_VALUE',
                 identifier: 'showPleaseWait',
                 value: true
             });
             dispatch(apiAction(
                 apiSchema,
                 pageContext.getProps().pageState,
                 [],
                 apiSchema.baseUrlName,
                 { productId: product.productId }
             ));
             dispatch({
                 type: 'HANDOVER_TO_PARTNER'
             });
         }
     };

    /**
     * Dispatch the action to progress to results page
     */
    goToResults = () => {
        const { dispatch } = this.props;
        dispatch({
            type: 'PROGRESS_TO_PAGE',
            pageName: 'results',
            // optional, if not passed in the action, saga will get from the pageContext
            pageSchemaModel: this.pageSchemaModel
        });
    };

    expiredQuoteImage = () => {
        const { expiredQuoteImage } = this.props;
        if (!expiredQuoteImage) {
            return null;
        }
        this.pictureSchema = {
            elementProps: {
                source: [{
                    srcSet: expiredQuoteImage
                }],
                image: {
                    alt: 'Expired Quote',
                    src: expiredQuoteImage,
                    title: 'Expired Quote'
                }
            },
            visualProps: {
                variant: 'full_width'
            }
        };
        return <Picture {...this.pictureSchema} />;
    };

    hasExpiredQuoteImage = () => {
        const { expiredQuoteImage } = this.props;
        return !!expiredQuoteImage;
    };

    /**
     * If productInfo is valid/notExpired, handover to partner, otherwise, render a quote expired messaging
     * @returns {Node|null} quote expired layouts with contents, or null but redirect user to partner
     */
    render = () => {
        const { productInfo } = this.props;
        const { isQuoteValid } = productInfo;

        return isQuoteValid === false ? (
            <SimpleFlexbox className={styles.root} container>
                <SimpleFlexbox row contentCenter="sm">
                    {this.hasExpiredQuoteImage() && (
                        <SimpleFlexbox xs={0} sm={2} smOffset={2}>
                            {this.expiredQuoteImage()}
                        </SimpleFlexbox>
                    )}
                    <SimpleFlexbox className={styles.content} xs={12} sm={6}>
                        <Text tagName="h1" label="Sorry, this quote has expired." color="brand_base" />
                        <InternalLink
                            className={styles.button}
                            data-id="quote_expired_redirect_start"
                            href={`${this.pageSchemaModel.getJourneyBasePageName()}/journey/start`}
                            label="Get new quotes"
                            UIComponent="btn_primary_transparent_xlarge_semi_rounded"
                        />
                    </SimpleFlexbox>
                </SimpleFlexbox>
            </SimpleFlexbox>
        ) : null;
    };

}

_InsurerHandoverPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    productInfo: PropTypes.shape({
        product: PropTypes.object,
        isQuoteValid: PropTypes.bool
    }).isRequired,
    expiredQuoteImage: PropTypes.string
};

/**
 * Get productInfo from state
 * @param {Immutable.Map} state - Redux store state.
 * @return {Object} - The state attrs to add to props.
 */
export const mapStateToProps = (state) => {
    const productInfo = productInfoSelector(state);
    const expiredQuoteImage = getExpiredQuoteImageSelector(state);
    // Need to check if productInfo is Immutable as BE could set it to null.
    return { productInfo: Map.isMap(productInfo) ? productInfo.toJS() : {}, expiredQuoteImage };
};

export const InsurerHandoverPage = connect(mapStateToProps)(_InsurerHandoverPage);
export { _InsurerHandoverPage };
